var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#006AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2498 10.6242V15.5485C11.2748 15.736 11.2123 15.936 11.0686 16.0672C11.0108 16.1251 10.9421 16.1711 10.8665 16.2025C10.7909 16.2338 10.7099 16.25 10.628 16.25C10.5462 16.25 10.4652 16.2338 10.3896 16.2025C10.314 16.1711 10.2453 16.1251 10.1875 16.0672L8.9314 14.8111C8.86324 14.7445 8.81142 14.663 8.77998 14.573C8.74854 14.4831 8.73834 14.387 8.75017 14.2925V10.6242H8.73143L5.13192 6.01236C5.03044 5.88208 4.98465 5.71694 5.00456 5.553C5.02447 5.38907 5.10845 5.23968 5.23816 5.13748C5.35689 5.04999 5.48812 5 5.62561 5H14.3744C14.5119 5 14.6431 5.04999 14.7618 5.13748C14.8916 5.23968 14.9755 5.38907 14.9954 5.553C15.0153 5.71694 14.9696 5.88208 14.8681 6.01236L11.2686 10.6242H11.2498Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimePickerIcon);
export default __webpack_public_path__ + "static/media/time-picker-icon.6086aaf65c3c8c4cd73d9c3fe801c826.svg";
export { ForwardRef as ReactComponent };